module.exports = __webpack_public_path__ + "img/hulan.576e4e2a.svg";